// Main navigation + mega-menu structure
export const NAV = [
  { label: "Accueil", to: "/" },
  {
    label: "Enseignes",
    mega: true,
    columns: [
      {
        heading: "Enseignes lumineuses",
        links: [
          { label: "Enseigne lumineuse", to: "/enseigne-lumineuse/" },
          { label: "Lettres lumineuses", to: "/lettres-lumineuses/" },
          { label: "Lettres boîtiers", to: "/lettres-boitiers/" },
          { label: "Lettres relief", to: "/lettres-relief/" },
        ],
      },
      {
        heading: "Volumes & LED",
        links: [
          { label: "Enseigne drapeau", to: "/enseigne-drapeau/" },
          { label: "Caisson lumineux", to: "/caisson-lumineux/" },
          { label: "Néon LED", to: "/neon-led/" },
          { label: "Totem publicitaire", to: "/totem-publicitaire/" },
        ],
      },
    ],
  },
  {
    label: "Signalétique",
    mega: true,
    columns: [
      {
        heading: "Signalétique",
        links: [
          { label: "Signalétique professionnelle", to: "/signaletique/" },
          { label: "Signalétique intérieure", to: "/signaletique-interieure/" },
          { label: "Signalétique extérieure", to: "/signaletique-exterieure/" },
          { label: "Totems & panneaux", to: "/totem-publicitaire/" },
        ],
      },
    ],
  },
  {
    label: "Communication visuelle",
    mega: true,
    columns: [
      {
        heading: "Communication visuelle",
        links: [
          { label: "Vue d'ensemble", to: "/communication-visuelle/" },
          { label: "Vitrophanie", to: "/vitrophanie/" },
          { label: "Marquage vitrine", to: "/marquage-vitrine/" },
        ],
      },
      {
        heading: "Impression & véhicules",
        links: [
          { label: "Films adhésifs", to: "/film-adhesif/" },
          { label: "Marquage véhicules", to: "/marquage-vehicule/" },
          { label: "Habillage façade", to: "/habillage-facade/" },
          { label: "Impression grand format", to: "/impression-grand-format/" },
        ],
      },
    ],
  },
  { label: "Réalisations", to: "/realisations/" },
  { label: "Secteurs", to: "/secteurs/" },
  { label: "Zones", to: "/zones-intervention/" },
  { label: "Conseils", to: "/conseils/" },
  { label: "À propos", to: "/a-propos/" },
];
